function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrayPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10 4.5C10 9.18629 10 11.8137 10 16.5",
    stroke: "#B3C0BD",
    style: {
      stroke: "#B3C0BD",
      stroke: "color(display-p3 0.7020 0.7529 0.7412)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 10.5L4 10.5",
    stroke: "#B3C0BD",
    style: {
      stroke: "#B3C0BD",
      stroke: "color(display-p3 0.7020 0.7529 0.7412)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayPlus);
export default __webpack_public_path__ + "static/media/grayPlus.56046658bf1ee94f34b55f47d7b831b8.svg";
export { ForwardRef as ReactComponent };